import { FunctionComponent, useState } from 'react'
import { Button, ButtonToolbar, Form, Modal, Spinner } from 'react-bootstrap'
import { useWorkroom } from './WorkroomContext'
import { createNewFolder } from 'Frontend/scripts/services/workrooms.service'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface SaveFolderForm {
  folderName: string
  description: string
}

const WorkroomCreateFolderButton: FunctionComponent = () => {
  const { permissions, currentWorkroomId, fetchFilesAndFolders, setIsLoading, isLoading, currentFolder } = useWorkroom()

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { t } = useTranslation()
  const form = useForm<SaveFolderForm>()

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = form

  const onSubmit = (data: SaveFolderForm) => {
    setIsLoading(true)
    if (!permissions?.createWorkroomFolder) return

    createNewFolder(currentWorkroomId as string, data.folderName, currentFolder !== 'root' ? currentFolder : null).then(
      (response) => {
        if (response) {
          reset()
          setIsLoading(false)
          fetchFilesAndFolders()
          setIsOpen(!isOpen)
        }
      },
    )
  }

  const handleClose = () => {
    reset()
    setIsOpen(!isOpen)
  }

  return (
    <>
      <Button
        variant="secondary"
        className="fw-normal"
        disabled={!permissions?.createWorkroomFolder}
        onClick={() => setIsOpen(!isOpen)}
      >
        <i className={`fa fa-folder-o small me-1`} />
        {t('workrooms.documents.new-folder-button-text')}
      </Button>
      <Modal show={isOpen} centered>
        <Modal.Header className="h4 mb-0">{t('workrooms.documents.new-folder-modal-title')}</Modal.Header>
        <Modal.Body>
          {isLoading && (
            <div
              className="d-flex top-0 start-0 bottom-0 end-0 h-100 
            justify-content-center position-absolute align-items-center"
            >
              <Spinner variant="secondary" animation="border" />
            </div>
          )}
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group>
              <Form.Label>{t('workrooms.documents.new-folder-name-label')}</Form.Label>
              <Form.Control
                {...register('folderName', {
                  required: { message: t('workrooms.documents.new-folder-name-required-validation-text'), value: true },
                })}
                type="text"
                disabled={isLoading}
                placeholder={t('workrooms.documents.new-folder-name-placeholder')}
                className={`${errors?.folderName ? 'is-invalid' : ''}`}
              />
              {errors?.folderName && <p className="invalid-feedback">{errors?.folderName.message}</p>}
            </Form.Group>
            <ButtonToolbar className="justify-content-between mt-3">
              <Button type="submit" variant="secondary" disabled={isLoading}>
                {t('save')}
              </Button>
              <Button type="button" variant="outline-secondary" onClick={() => handleClose()} disabled={isLoading}>
                {t('abort')}
              </Button>
            </ButtonToolbar>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  )
}
export default WorkroomCreateFolderButton
